// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.seller-dashboard-main-div {
  padding-top: 1rem !important;
}

.welcome-header {
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.welcome-header-css {
  color: var(--Colors-Text-500, #0a0f0d);
}

.welcome-username-css {
  color: var(--Colors-Primary-500, #d2042d);
}

.seller-dashboard-div-css {
  border-radius: 0.625rem;
  background: #fff;
  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
}

.seller-dashboard-div-layout {
  height: 100%;
  padding: 1.2rem;
}

.billboard-carousel .slick-track {
  display: flex !important;
}

.ant-carousel .billboard-carousel .slick-dots li.slick-active button {
  background: #d2042d;
}

.ant-carousel .billboard-carousel .slick-dots li button {
  background: #b3b5b4;
}

.billboard-carousel .slick-slide {
  height: 23rem !important;
  max-height: 100% !important;
}

.billboard-carousel .slick-slide > div {
  height: 100% !important;
}

.billboard-carousel .slick-slide > div > .ant-col {
  height: 100% !important;
}

.seller-dashboard-child-div-header-css {
  margin-bottom: 1rem;
  color: var(--Colors-Text-300, #5b5e5d);
  font-size: 14px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
}

.seller-dashboard-child-div-sub-header-css {
  font-family: Roboto;
  color: var(--Colors-Text-200, #8e9190);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.seller-dashboard-child-div-sub-header-value-css {
  font-family: Roboto;
  color: #000;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.seller-dashboard-child-div-sub-header-value-size-css {
  font-size: var(--Font-Font-Size-h6, 1.1875rem);
}

.sub-headers-div {
  display: flex;
  justify-content: space-between;
}

.seller-dashboard-actions-div {
  gap: 0.9rem;
  display: flex;
  flex-direction: column;
  cursor: pointer;
}

.seller-dashboard-actions-child-div {
  font-family: Roboto;
  gap: 0.5rem;
  height: 50%;
  padding: 0rem 2.1875rem 0 3rem;
  align-items: center;
  font-size: var(--Font-Font-Size-p, 14px);
  color: var(--Colors-Primary-500, #d2042d);
  font-weight: 700;
  border-radius: 0.625rem;
  background: #fff;
  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
}

.revenue-performance {
  border-radius: 0.3125rem;
  background: #f5f5f5;
  display: inline-flex;
  height: 2.1875rem;
  /* padding: 0.5rem; */
  justify-content: center;
  align-items: center;
}

.revenue-performance-tab-1 {
  font-family: Roboto;
  padding: 0.5rem;
  color: #838383;
  cursor: pointer;
}

.revenue-performance-tab-2 {
  font-family: Roboto;
  font-weight: 500;
  padding: 0.3rem;
  border-radius: 0.3rem;
  cursor: pointer;
  background: #fff;
  box-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.17);
}

.revenue-performance-years-tab {
  display: flex;
  /* width: 5.8125rem; */
  font-weight: 500;
  height: 2.1875rem;
  /* margin-left: 1rem; */
  padding: 0.5rem;
  justify-content: center;
  align-items: center;
  gap: 0.8125rem;
  border-radius: 0.3125rem;
  background: #f5f5f5;
}

.revenue-performance-icons {
  cursor: pointer;
}

.seller-dashboard-revenue-chart .recharts-cartesian-axis-tick-line {
  display: none;
}

.seller-dashboard-revenue-chart {
  .recharts-tooltip-cursor {
    display: none;
  }
}

.card-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  position: relative;
}

.card-wrapper {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  height: 8.875rem;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  background: white;
  justify-content: center;
}

.card-wrapper .ant-card-body {
  padding-top: 4rem !important;
  border-radius: 0 0 8px 8px;
}

.seller-premium-recommendation {
  width: fit-content;
  border-radius: 0.3125rem;
  border: 1px solid #d2d2d2;
  background: #f5f5f5;
  right: 1.36763rem;
  padding: 0.5rem;
  align-items: center;
  gap: 0.375rem;
  top: 1.25rem;
}

.seller-premium-recommendation-text {
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
}
.billboard-buttons-div {
  text-align: right;
  gap: 1rem;
  display: flex;
  justify-content: flex-end;
}
.billboard-buttons {
  font-family: Roboto;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  padding: 0.5rem 1.5rem;
}

.billboard-button-1 {
  font-family: Roboto;
  background-color: #f0f0f0;
  border: none;
}

.billboard-button-1:hover {
  background-color: #c7c7c7 !important;
  color: var(--Colors-Text-500, #0a0f0d) !important;
  border: none;
}

.billboard-button-2 {
  border-color: #d2042d !important;
  font-family: Roboto;
  background-color: #d2042d !important;
  color: white !important;
  border-color: #d2042d !important;
}

.seller-dashboard-main-div .billboard-button-2:hover {
  background-color: #910621 !important;
  color: white !important;
  border: none;
}

.billboard-dialog .ant-modal-title {
  font-family: Montserrat;
  font-weight: 700;
  font-size: 20px;
}

.billboard-carousel .slick-dots button {
  width: 5px !important;
  height: 5px !important;
}

.ant-carousel:has(.billboard-carousel) {
  width: 100% !important;
}

.seller-dashboard-custom-tooltip {
  display: flex;
  background-color: white;
  padding: 5px 10px;
  border-radius: 5px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
  align-items: center;
  gap: 0.5rem;
}
/* 
.recharts-cartesian-axis tspan {
  font-family: Roboto;
} */

.seller-dashboard-custom-tooltip-text {
  font-family: Roboto;
  color: #d2042d;
  font-weight: bold;
}

.seller-dashboard-custom-tooltip-date {
  font-family: Roboto;
  color: #9e9e9e;
  font-size: 12px;
}

.seller-dashboard-carousel-row {
  gap: 2rem;
  margin-bottom: 2rem;
}

.seller-dashboard-carousel-col {
  display: flex;
  height: 100%;
  width: 100%;
}

.seller-dashboard-carousel-div-css {
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
}

.seller-dashboard-row {
  gap: 2%;
  margin-bottom: 2rem;
  width: 100%;
}

.seller-dashboard-offering-css {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 95%;
  position: relative;
}

.seller-dashboard-col {
  width: 100%;
  min-height: 22rem;
  margin-bottom: 2rem;
}

.seller-dashboard-offering-div {
  display: flex;
  margin-bottom: 1.5rem;
  justify-content: space-between;
}

.seller-dashboard-col-sub-div {
  height: 100%;
  padding: 10px;
}

.seller-dashboard-back-arrow {
  padding-left: 1rem;
  padding-top: 1rem;
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
.month-select {
  font-family: Roboto;
  border: "1px solid #f5f5f5";
  display: flex;
  width: 139px;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 13px;
  border-radius: 5px;
  background: #f5f5f5;
  /* margin-left: 0.6875rem; */
}

.month-select .ant-select-selector {
  background: #f5f5f5 !important;
}
.performance-div {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 1rem;
}
@media (max-width: 768px) {
  .welcome-header {
    font-size: 16px !important;
  }
  .seller-dashboard-child-div-header-css {
    font-size: 12px;
  }
  .seller-dashboard-actions-child-div {
    justify-content: center;
    align-items: center;
    color: #fff;
    padding: 0.5rem 0.125rem 0.5rem 0.1875rem !important;
    font-weight: 700;
    border-radius: 1.625rem;
    background: var(--Colors-Primary-500, #d2042d);
    box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
  }

  .seller-dashboard-actions-div {
    height: 100%;
  }

  .card-wrapper .ant-card-body {
    align-items: center;
    height: 100%;
    display: flex;
    padding-top: 1rem !important;
  }
  .card-wrapper {
    display: block;
  }

  .seller-dashboard-div-layout {
    height: 100%;
    padding: 1.5rem;
  }
  .performance-div {
    flex-direction: column;
    align-items: stretch;
    gap: 0.5rem;
    width: 100%;
    /* padding: 0.5rem 0; */
  }
  .revenue-performance {
    width: 100%;
    justify-content: flex-start;
    margin-bottom: 0.5rem;
    padding-left: 0.5rem !important;
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }
  .revenue-performance-years-tab {
    width: 100%;
    justify-content: flex-start;
    margin-bottom: 0.5rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  .month-select {
    width: 100% !important;
    margin-bottom: 0.5rem;
    font-size: 1rem;
  }
  @media (max-width: 480px) {
    .performance-div {
      gap: 0.25rem;
      padding: 0.25rem 0;
    }
    .revenue-performance {
      font-size: 0.95rem;
      gap: 0.25rem;
    }
    .revenue-performance-years-tab {
      font-size: 0.95rem;
      gap: 0.25rem;
    }
    .month-select {
      font-size: 0.95rem;
    }
  }
  .mobile-year-tab {
    margin-left: 0 !important;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .billboard-carousel .slick-dots li button {
    width: 10px !important;
    height: 10px !important;
    border-radius: 50% !important;
    background-color: #666 !important;
    opacity: 0.5 !important;
  }
  .billboard-carousel .slick-dots li {
    height: 12px !important;
  }
  .billboard-carousel .slick-dots li.slick-active button {
    background-color: #d2042d !important;
    opacity: 1 !important;
  }

  .billboard-carousel .slick-dots {
    bottom: -30px !important; /* adjust as needed */
  }
  .seller-dashboard-main-div .ant-carousel .slick-dots li::after {
    background: #d2042d !important;
    height: auto;
  }
  .billboard-carousel .ant-carousel .slick-active::after li {
    height: 12px !important;
    width: 20px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/SellerFlow/dashboard/SellerDashboard.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;EACnB,wCAAwC;EACxC,yCAAyC;EACzC,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,SAAS;EACT,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,iDAAiD;EACjD,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,oCAAoC;EACpC,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,WAAW;AACb;AACA;;;GAGG;;AAEH;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,OAAO;EACP,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,oDAAoD;IACpD,gBAAgB;IAChB,uBAAuB;IACvB,8CAA8C;IAC9C,kDAAkD;EACpD;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,4BAA4B;EAC9B;EACA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;IACX,WAAW;IACX,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,2BAA2B;IAC3B,qBAAqB;IACrB,+BAA+B;IAC/B,aAAa;IACb,eAAe;IACf,WAAW;EACb;EACA;IACE,WAAW;IACX,2BAA2B;IAC3B,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,qBAAqB;IACrB,eAAe;EACjB;EACA;IACE;MACE,YAAY;MACZ,kBAAkB;IACpB;IACA;MACE,kBAAkB;MAClB,YAAY;IACd;IACA;MACE,kBAAkB;MAClB,YAAY;IACd;IACA;MACE,kBAAkB;IACpB;EACF;EACA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;IAC7B,iCAAiC;IACjC,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,oCAAoC;IACpC,qBAAqB;EACvB;;EAEA;IACE,wBAAwB,EAAE,qBAAqB;EACjD;EACA;IACE,8BAA8B;IAC9B,YAAY;EACd;EACA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;AACF","sourcesContent":[".seller-dashboard-main-div {\n  padding-top: 1rem !important;\n}\n\n.welcome-header {\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.welcome-header-css {\n  color: var(--Colors-Text-500, #0a0f0d);\n}\n\n.welcome-username-css {\n  color: var(--Colors-Primary-500, #d2042d);\n}\n\n.seller-dashboard-div-css {\n  border-radius: 0.625rem;\n  background: #fff;\n  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n}\n\n.seller-dashboard-div-layout {\n  height: 100%;\n  padding: 1.2rem;\n}\n\n.billboard-carousel .slick-track {\n  display: flex !important;\n}\n\n.ant-carousel .billboard-carousel .slick-dots li.slick-active button {\n  background: #d2042d;\n}\n\n.ant-carousel .billboard-carousel .slick-dots li button {\n  background: #b3b5b4;\n}\n\n.billboard-carousel .slick-slide {\n  height: 23rem !important;\n  max-height: 100% !important;\n}\n\n.billboard-carousel .slick-slide > div {\n  height: 100% !important;\n}\n\n.billboard-carousel .slick-slide > div > .ant-col {\n  height: 100% !important;\n}\n\n.seller-dashboard-child-div-header-css {\n  margin-bottom: 1rem;\n  color: var(--Colors-Text-300, #5b5e5d);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 800;\n  line-height: normal;\n}\n\n.seller-dashboard-child-div-sub-header-css {\n  font-family: Roboto;\n  color: var(--Colors-Text-200, #8e9190);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.seller-dashboard-child-div-sub-header-value-css {\n  font-family: Roboto;\n  color: #000;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.seller-dashboard-child-div-sub-header-value-size-css {\n  font-size: var(--Font-Font-Size-h6, 1.1875rem);\n}\n\n.sub-headers-div {\n  display: flex;\n  justify-content: space-between;\n}\n\n.seller-dashboard-actions-div {\n  gap: 0.9rem;\n  display: flex;\n  flex-direction: column;\n  cursor: pointer;\n}\n\n.seller-dashboard-actions-child-div {\n  font-family: Roboto;\n  gap: 0.5rem;\n  height: 50%;\n  padding: 0rem 2.1875rem 0 3rem;\n  align-items: center;\n  font-size: var(--Font-Font-Size-p, 14px);\n  color: var(--Colors-Primary-500, #d2042d);\n  font-weight: 700;\n  border-radius: 0.625rem;\n  background: #fff;\n  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n}\n\n.revenue-performance {\n  border-radius: 0.3125rem;\n  background: #f5f5f5;\n  display: inline-flex;\n  height: 2.1875rem;\n  /* padding: 0.5rem; */\n  justify-content: center;\n  align-items: center;\n}\n\n.revenue-performance-tab-1 {\n  font-family: Roboto;\n  padding: 0.5rem;\n  color: #838383;\n  cursor: pointer;\n}\n\n.revenue-performance-tab-2 {\n  font-family: Roboto;\n  font-weight: 500;\n  padding: 0.3rem;\n  border-radius: 0.3rem;\n  cursor: pointer;\n  background: #fff;\n  box-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.17);\n}\n\n.revenue-performance-years-tab {\n  display: flex;\n  /* width: 5.8125rem; */\n  font-weight: 500;\n  height: 2.1875rem;\n  /* margin-left: 1rem; */\n  padding: 0.5rem;\n  justify-content: center;\n  align-items: center;\n  gap: 0.8125rem;\n  border-radius: 0.3125rem;\n  background: #f5f5f5;\n}\n\n.revenue-performance-icons {\n  cursor: pointer;\n}\n\n.seller-dashboard-revenue-chart .recharts-cartesian-axis-tick-line {\n  display: none;\n}\n\n.seller-dashboard-revenue-chart {\n  .recharts-tooltip-cursor {\n    display: none;\n  }\n}\n\n.card-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px;\n  position: relative;\n}\n\n.card-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  width: 100%;\n  height: 8.875rem;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  background: white;\n  justify-content: center;\n}\n\n.card-wrapper .ant-card-body {\n  padding-top: 4rem !important;\n  border-radius: 0 0 8px 8px;\n}\n\n.seller-premium-recommendation {\n  width: fit-content;\n  border-radius: 0.3125rem;\n  border: 1px solid #d2d2d2;\n  background: #f5f5f5;\n  right: 1.36763rem;\n  padding: 0.5rem;\n  align-items: center;\n  gap: 0.375rem;\n  top: 1.25rem;\n}\n\n.seller-premium-recommendation-text {\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 500;\n}\n.billboard-buttons-div {\n  text-align: right;\n  gap: 1rem;\n  display: flex;\n  justify-content: flex-end;\n}\n.billboard-buttons {\n  font-family: Roboto;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 500;\n  padding: 0.5rem 1.5rem;\n}\n\n.billboard-button-1 {\n  font-family: Roboto;\n  background-color: #f0f0f0;\n  border: none;\n}\n\n.billboard-button-1:hover {\n  background-color: #c7c7c7 !important;\n  color: var(--Colors-Text-500, #0a0f0d) !important;\n  border: none;\n}\n\n.billboard-button-2 {\n  border-color: #d2042d !important;\n  font-family: Roboto;\n  background-color: #d2042d !important;\n  color: white !important;\n  border-color: #d2042d !important;\n}\n\n.seller-dashboard-main-div .billboard-button-2:hover {\n  background-color: #910621 !important;\n  color: white !important;\n  border: none;\n}\n\n.billboard-dialog .ant-modal-title {\n  font-family: Montserrat;\n  font-weight: 700;\n  font-size: 20px;\n}\n\n.billboard-carousel .slick-dots button {\n  width: 5px !important;\n  height: 5px !important;\n}\n\n.ant-carousel:has(.billboard-carousel) {\n  width: 100% !important;\n}\n\n.seller-dashboard-custom-tooltip {\n  display: flex;\n  background-color: white;\n  padding: 5px 10px;\n  border-radius: 5px;\n  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);\n  align-items: center;\n  gap: 0.5rem;\n}\n/* \n.recharts-cartesian-axis tspan {\n  font-family: Roboto;\n} */\n\n.seller-dashboard-custom-tooltip-text {\n  font-family: Roboto;\n  color: #d2042d;\n  font-weight: bold;\n}\n\n.seller-dashboard-custom-tooltip-date {\n  font-family: Roboto;\n  color: #9e9e9e;\n  font-size: 12px;\n}\n\n.seller-dashboard-carousel-row {\n  gap: 2rem;\n  margin-bottom: 2rem;\n}\n\n.seller-dashboard-carousel-col {\n  display: flex;\n  height: 100%;\n  width: 100%;\n}\n\n.seller-dashboard-carousel-div-css {\n  width: 100%;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.seller-dashboard-row {\n  gap: 2%;\n  margin-bottom: 2rem;\n  width: 100%;\n}\n\n.seller-dashboard-offering-css {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 95%;\n  position: relative;\n}\n\n.seller-dashboard-col {\n  width: 100%;\n  min-height: 22rem;\n  margin-bottom: 2rem;\n}\n\n.seller-dashboard-offering-div {\n  display: flex;\n  margin-bottom: 1.5rem;\n  justify-content: space-between;\n}\n\n.seller-dashboard-col-sub-div {\n  height: 100%;\n  padding: 10px;\n}\n\n.seller-dashboard-back-arrow {\n  padding-left: 1rem;\n  padding-top: 1rem;\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n}\n.month-select {\n  font-family: Roboto;\n  border: \"1px solid #f5f5f5\";\n  display: flex;\n  width: 139px;\n  padding: 8px;\n  justify-content: center;\n  align-items: center;\n  gap: 13px;\n  border-radius: 5px;\n  background: #f5f5f5;\n  /* margin-left: 0.6875rem; */\n}\n\n.month-select .ant-select-selector {\n  background: #f5f5f5 !important;\n}\n.performance-div {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: 1rem;\n}\n@media (max-width: 768px) {\n  .welcome-header {\n    font-size: 16px !important;\n  }\n  .seller-dashboard-child-div-header-css {\n    font-size: 12px;\n  }\n  .seller-dashboard-actions-child-div {\n    justify-content: center;\n    align-items: center;\n    color: #fff;\n    padding: 0.5rem 0.125rem 0.5rem 0.1875rem !important;\n    font-weight: 700;\n    border-radius: 1.625rem;\n    background: var(--Colors-Primary-500, #d2042d);\n    box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n  }\n\n  .seller-dashboard-actions-div {\n    height: 100%;\n  }\n\n  .card-wrapper .ant-card-body {\n    align-items: center;\n    height: 100%;\n    display: flex;\n    padding-top: 1rem !important;\n  }\n  .card-wrapper {\n    display: block;\n  }\n\n  .seller-dashboard-div-layout {\n    height: 100%;\n    padding: 1.5rem;\n  }\n  .performance-div {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.5rem;\n    width: 100%;\n    /* padding: 0.5rem 0; */\n  }\n  .revenue-performance {\n    width: 100%;\n    justify-content: flex-start;\n    margin-bottom: 0.5rem;\n    padding-left: 0.5rem !important;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n  .revenue-performance-years-tab {\n    width: 100%;\n    justify-content: flex-start;\n    margin-bottom: 0.5rem;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n  }\n  .month-select {\n    width: 100% !important;\n    margin-bottom: 0.5rem;\n    font-size: 1rem;\n  }\n  @media (max-width: 480px) {\n    .performance-div {\n      gap: 0.25rem;\n      padding: 0.25rem 0;\n    }\n    .revenue-performance {\n      font-size: 0.95rem;\n      gap: 0.25rem;\n    }\n    .revenue-performance-years-tab {\n      font-size: 0.95rem;\n      gap: 0.25rem;\n    }\n    .month-select {\n      font-size: 0.95rem;\n    }\n  }\n  .mobile-year-tab {\n    margin-left: 0 !important;\n    margin-top: 0.5rem;\n    margin-bottom: 0.5rem;\n  }\n  .billboard-carousel .slick-dots li button {\n    width: 10px !important;\n    height: 10px !important;\n    border-radius: 50% !important;\n    background-color: #666 !important;\n    opacity: 0.5 !important;\n  }\n  .billboard-carousel .slick-dots li {\n    height: 12px !important;\n  }\n  .billboard-carousel .slick-dots li.slick-active button {\n    background-color: #d2042d !important;\n    opacity: 1 !important;\n  }\n\n  .billboard-carousel .slick-dots {\n    bottom: -30px !important; /* adjust as needed */\n  }\n  .seller-dashboard-main-div .ant-carousel .slick-dots li::after {\n    background: #d2042d !important;\n    height: auto;\n  }\n  .billboard-carousel .ant-carousel .slick-active::after li {\n    height: 12px !important;\n    width: 20px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
